import { render, staticRenderFns } from "./ParcelleEditionDialog.vue?vue&type=template&id=0b8373a4"
import script from "./ParcelleEditionDialog.vue?vue&type=script&lang=js"
export * from "./ParcelleEditionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports